import { render, staticRenderFns } from "./TranslationSettings.vue?vue&type=template&id=31571c02&"
import script from "./TranslationSettings.vue?vue&type=script&lang=js&"
export * from "./TranslationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports